import { z } from 'zod';

import { zodSuccessResponseSchema } from '@vestigas/data';

/**
 * Envelope returned by endpoints that create several resources at once
 * (`CreatedList` in the OpenAPI spec).
 */
export const zodCreatedListResponseSchema = zodSuccessResponseSchema.extend({
  ids: z.array(z.uuid()).nullish(),
});
